export default __webpack_public_path__ + "static/media/8.1b8d0cde.webp";